import React from "react";

class ContactBanner extends React.Component {
  render() {
    return (
      <section className="connect-section-header">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
                &nbsp;&nbsp;
            </div>
          </div>
        </div>
      </section>
    );
  }
}

export default ContactBanner;



// WEBPACK FOOTER //
// ./src/pages/connect/ConnectBanner.js